import _ from 'lodash';
import state, * as getters from './state';
import * as actions from './actions';
import * as mutations from './mutations';
import * as constants from '../constants';

const nms = [ constants.NAMESPACE, 'store' ].join('/');
const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @typedef {Object} StoreOpts
 * @property {string} namespace
 * @property {import('vuex').Store} store
 * @property {import('@mycure/sdk').CoreService} sdk
 */

export default {
  /**
   * @param {import('vue').Component} Vue
   * @param {StoreOpts} opts
   */
  install (Vue, opts) {
    const { store, sdk, ...resopts } = opts = Object.assign({ namespace: constants.NAMESPACE }, opts);
    if (!store) throw new Error(`${nms}: Vuex store required`);
    if (!sdk) throw new Error(`${nms}: SDK required`);

    log('installing with opts', resopts);
    store.registerModule(opts.namespace, {
      namespaced: true,
      state,
      getters: _.pickBy(getters, m => typeof m === 'function'),
      mutations: _.pickBy(mutations, m => typeof m === 'function'),
      actions: _.mapValues(
        _.pickBy(actions, m => typeof m === 'function'),
        actionFactory => actionFactory(store, sdk)
      )
    });
  }
};
